/**
 * The live site. Analytics and error reporting only run here, so local
 * sessions and the go.eyejack.dev / go.eyejack.io deploys stay out of the
 * client's numbers.
 */
export const LIVE_HOSTNAME = "kangaroopoint.hornsby.nsw.gov.au";

export const isLiveSite = (): boolean =>
  typeof window !== "undefined" && window.location.hostname === LIVE_HOSTNAME;
